<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ReviewsProductCampaigns :product="product" />
  <ReviewsProductReviews :product="product" />
</template>

<script setup lang="ts">
import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { useReviewsProductBreadcrumbs } from '@/composables/breadcrumbs/useReviewsProductBreadcrumbs'
import { type ProductData } from '@/gql/reviews'

import ReviewsProductCampaigns from './ReviewsProductCampaigns.vue'
import ReviewsProductReviews from './ReviewsProductReviews.vue'

const props = defineProps<{
  product: ProductData
}>()

const breadcrumbs = useReviewsProductBreadcrumbs(props.product)
</script>
